<template>
  <sModal
    :title="$t('Tenders.DownloadTendersToExcel')"
    :value="open"
    @close="$emit('update:open', false)">
    <TooltipedBtn
      slot="activator"
      data-qa="btn-export-to-excel"
      :disabled="loading || disabled"
      icon="excel"
      :loading="loading"
      :small-btn="smallBtn"
      :text="$t('Tenders.DownloadTendersToExcel')"
      :texted="onlyIcon ? null : $t('Tenders.DownloadTendersToExcel') "
      @click="$emit('update:open', true)"/>
    <slot name="dialogContent"/>
    <div
      key="footer"
      slot="footer">
      <sButton
        key="btn-ok"
        data-qa="btn-ok-dialog"
        type="black"
        @click="$emit('ok')">
        {{ $t(okText) }}
      </sButton>
      <sButton
        key="btn-cancel"
        data-qa="btn-close-dialog"
        type="text"
        @click="$emit('update:open', false)">
        {{ $t(cancelText) }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
import TooltipedBtn from 'components/common/elements/TooltipedBtn.vue'

export default {
  name: 'exportToExcel',
  props: {
    open: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    cancelText: {
      type: String,
      default: 'Common.Close'
    },
    okText: {
      type: String,
      default: 'Common.Apply'
    },
    onlyIcon: {
      type: Boolean,
      default: true
    },
    /**
     * Маленькая кнопка
     */
    smallBtn: {
      type: Boolean
    },
  },
  components: {
    TooltipedBtn
  }
}
</script>
